import React from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import IndexCard from "../../../shared/IndexCard/IndexCard";
import { Link, useOutletContext } from "react-router-dom";

const ProjectListPage = () => {
  const {
    contractExists,
    isActive,
    projects,
    loading,
    hasSearchFilters,
    handleMarkedRead,
    hasExecutedSearch,
    isSearching,
  } = useOutletContext();

  const openProjects = projects;
  // id が新しい順（降順）に並べた表示用配列
  // const projectsSortedByIdDesc = useMemo(() => {
  //   return [...projects].sort((leftProject, rightProject) => {
  //     return rightProject.id - leftProject.id;
  //   });
  // }, [projects]);

  // 検索に一致する結果がない場合のメッセージ
  const shouldShowNoResultsMessage = hasExecutedSearch && hasSearchFilters && !isSearching;

  return (
    <>
      <Box sx={{ maxWidth: 960, mx: "auto", mb: 10 }}>
        {loading ? (
          <Box display="flex" justifyContent="center" mt={5}>
            <CircularProgress />
          </Box>
        ) : openProjects.length === 0 ? (
          <Typography color="text.secondary" sx={{ mt: 4 }}>
            {shouldShowNoResultsMessage ? (
              <>
                検索条件と一致する結果が見つかりません。
              </>
            ) : (
              <>
                現在、公開中のプロジェクトはありません。
                <br />
                お問い合わせ内容をもとに、条件に合うプロジェクトをご案内できる場合があります。
                <br />
                お問い合わせフォームよりお気軽にご連絡ください。
              </>
            )}
          </Typography>
        ) : (
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
              gap: { xs: 1, sm: 2 },
            }}
          >
            {openProjects.map((project) => {
              return (
                <IndexCard
                  key={project.id}
                  item={project}
                  type="project"
                  component={Link}
                  to={`/projects/${project.id}`}
                  onMarkedRead={handleMarkedRead}
                  contractExists={contractExists}
                  isActive={isActive}
                />
              );
            })}
          </Box>
        )}
      </Box>
    </>
  );
};

export default ProjectListPage;
